import { render, staticRenderFns } from "./createEditPartmentDialog.vue?vue&type=template&id=ef59fe8c&scoped=true"
import script from "./createEditPartmentDialog.vue?vue&type=script&lang=js"
export * from "./createEditPartmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef59fe8c",
  null
  
)

export default component.exports